import React, { useState, useRef, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { FaMicrophone, FaPaperPlane, FaStop } from "react-icons/fa";
import axios from "axios";
import "./Iva.css";

const Iva = ({ messages, setMessages }) => {
  const [input, setInput] = useState("");
  const [isApiInProgress, setIsApiInProgress] = useState(false);
  const [isRecording, setIsRecording] = useState(false);

  const inputRef = useRef(null);
  const recognition = useRef(null);
  const speechEndTimeout = useRef(null);
  const chatEndRef = useRef(null);

  /* Auto-scroll */
  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, isApiInProgress]);

  const handleMicClick = () => {
    if (isRecording) {
      recognition.current?.stop();
      return;
    }

    recognition.current =
      new (window.SpeechRecognition || window.webkitSpeechRecognition)();

    recognition.current.lang = "en-US";
    recognition.current.continuous = false;
    recognition.current.interimResults = false;

    recognition.current.onstart = () => setIsRecording(true);

    recognition.current.onspeechend = () => {
      speechEndTimeout.current = setTimeout(() => {
        recognition.current?.stop();
      }, 3000);
    };

    recognition.current.onresult = (event) => {
      clearTimeout(speechEndTimeout.current);
      setInput(event.results[0][0].transcript);
      setIsRecording(false);
      inputRef.current?.focus();
    };

    recognition.current.onerror = () => setIsRecording(false);
    recognition.current.onend = () => setIsRecording(false);

    recognition.current.start();
  };

  const handleSend = () => {
    if (!input.trim()) return;

    const messageText = input;
    setInput("");

    setMessages((prev) => [...prev, { text: messageText, isUser: true }]);
    setIsApiInProgress(true);

    axios({
      url:"https://wa278175geninaeuwa02-apim.azure-api.net/getAccentureContent",
      method: "post",
      data: {
        skill: "angular",
        prompt: messageText,
        user: localStorage.user?.split("@")[0],
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: `${localStorage.token}`,
      },
    })
      .then((res) => {
        setMessages((prev) => [
          ...prev,
          { text: res.data?.[0] || "No response", isUser: false },
        ]);
      })
      .catch(() => {
        setMessages((prev) => [
          ...prev,
          { text: "Some error occurred", isUser: false },
        ]);
      })
      .finally(() => setIsApiInProgress(false));
  };

  const getInitials = (name = "") =>
    name
      .split(",")
      .map((p) => p.trim()[0])
      .reverse()
      .join("")
      .toUpperCase();

  return (
    <div className="ignite-container popup">
      <div className="ignite-chat-wrapper">
        {/* CHAT */}
        <div className="ignite-chat">
          {messages.map((msg, index) => (
            <div
              key={index}
              className={`ignite-message ${msg.isUser ? "user" : "bot"}`}
            >
              {!msg.isUser && (
                <div className="ignite-avatar">
                  <img src="./Assets/askivabot.png" alt="Bot" />
                </div>
              )}

              <div className={`ignite-bubble ${msg.isUser ? "user" : "bot"}`}>
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                  {msg.text}
                </ReactMarkdown>
              </div>

              {msg.isUser && (
                <div className="ignite-avatar user">
                  {getInitials(localStorage.name)}
                </div>
              )}
            </div>
          ))}

          {isApiInProgress && (
            <div className="ignite-message bot">
              <div className="ignite-avatar">
                <img src="./Assets/askivabot.png" alt="Bot" />
              </div>
              <div className="ignite-bubble bot">
                <span className="typing-dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              </div>
            </div>
          )}

          <div ref={chatEndRef} />
        </div>

        {/* INPUT */}
        <div className="ignite-input-section">
          <div className={`ignite-input-box ${input ? "active" : ""}`}>
            <input
              ref={inputRef}
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSend()}
              placeholder="Ask me anything..."
            />

            <div className="ignite-input-buttons">
              {!isRecording ? (
                <FaMicrophone
                  className="ignite-input-icon mic"
                  onClick={handleMicClick}
                />
              ) : (
                <FaStop
                  className="ignite-input-icon mic recording"
                  onClick={() => recognition.current?.stop()}
                />
              )}

              <FaPaperPlane
                className="ignite-input-icon send"
                onClick={handleSend}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Iva;
